exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.datepicker[data-v-af3ee6c0] .mdi-calendar-range:hover::before {\n  color: #3076d8;\n}\n.datepicker[data-v-af3ee6c0] input,\n.datepicker[data-v-af3ee6c0] .v-text-field__slot,\n.datepicker[data-v-af3ee6c0] .v-input__slot {\n  cursor: pointer;\n}\n", ""]);

